import messages from './exchange-form-lang.json';
import VueFocus from 'vue-focus';
import debounce from 'lodash-es/debounce';
import { required } from 'vuelidate/lib/validators';
import notSameAs from '../../../common/js/validators/not-same-as';
import VueSelect from '../../../common/components/vue-select/vue-select.vue';
import { VueSelectOption } from '@ui-common/vue-select';
import VueTab from '@ui-common/vue-tab';
import VueCurrencyInput from '@ui-common/vue-currency-input';
export default {
	props: ['currencies'],
	mixins: [VueFocus.mixin],
	components: {
		VueSelect,
		VueSelectOption,
		VueTab,
		VueCurrencyInput
	},
	data() {
		return {
			baseCurrency: null,
			resultCurrency: null,
			model: {
				exchangeType: 'CURRENCY',
				baseAmount: '',
				baseCurrency: null,
				resultCurrency: null
			},
			focusedTab: null,
			amountA11yLabel: {}
		};
	},
	i18n: { messages },
	validations() {
		return {
			model: {
				baseCurrency: {
					required,
					notSameAs: notSameAs('resultCurrency')
				},
				resultCurrency: {
					required
				},
				baseAmount: {
					required
				},
				exchangeType: {
					required
				}
			}
		};
	},
	watch: {
		currencies(currencies) {
			if (currencies && currencies.currencies && currencies.currencies.length) {
				this.model.baseCurrency = currencies.defaults.from;
				this.model.resultCurrency = currencies.defaults.to;
			}
		},
		'model.exchangeType': function () {
			this.updateForm();
		},
		'model.baseCurrency'(newVal) {
			this.amountA11yLabel = this.currencies.currencies.find((item) => {
				return item.currencyCode == newVal;
			});
		}
	},
	computed: {
		isMobile() {
			return this.$resize && this.$mq.below(767);
		}
	},
	methods: {
		changeExchangeType(tabindex) {
			if (tabindex == 0) {
				this.model.exchangeType = 'CURRENCY';
			} else {
				this.model.exchangeType = 'FOREIGN_EXCHANGE';
			}
		},
		updateForm() {
			this.$v.$touch();
			if (!this.$v.$invalid) {
				this.submitForm();
			} else {
				this.resetResults();
			}
		},
		submitForm: debounce(function () {
			this.$emit('on-update-form', this.model);
		}, 200),
		resetResults() {
			this.$emit('on-reset-results');
		},
		changeDirection() {
			if (this.model.baseCurrency && this.model.resultCurrency) {
				[this.model.baseCurrency, this.model.resultCurrency] = [this.model.resultCurrency, this.model.baseCurrency];
			} else {
				if (this.model.baseCurrency) {
					this.model.resultCurrency = this.model.baseCurrency;
					this.model.baseCurrency = undefined;
				} else if (this.model.resultCurrency) {
					this.model.baseCurrency = this.model.resultCurrency;
					this.model.resultCurrency = undefined;
				}
			}
			this.updateForm();
		},
		changeTab(tabId) {
			this.model.exchangeType = tabId == '0' ? 'CURRENCY' : 'FOREIGN_EXCHANGE';
			this.focusedTab = tabId;
		}
	}
};
